import { useKeycloak } from "@react-keycloak/web";
import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useAppContext } from "../../../context/app-context";
import useDocumentTitle from "../../../hooks/use-document-title";
import { getAccessToken, setUsername } from "../../../utils/token-functions";
import Loader from "../../loader/Loader";

export default function BaseLayout() {
  const { t } = useTranslation(["pageTitle"]);
  useDocumentTitle(t("title", { ns: "pageTitle" }));
  const { setRole, setUser, setProfile } = useAppContext();
  const { keycloak } = useKeycloak();

  useEffect(() => {
    const token = getAccessToken();
    if (token) {
      const details: any = jwtDecode(token ?? "");
      keycloak.loadUserProfile().then((res: any) => {
        setUsername(res?.username ?? "");
        setUser({ ...details, ...res });
        setProfile(res);
        setRole(
          details.resource_access?.["nautilus-user"]?.roles?.[0] ||
            details.resource_access?.["nautilus-admin"]?.roles?.[0]
        );
      });
    }
  }, []);

  return (
    <>
      <Loader />
      <Outlet />
      <ScrollRestoration
        getKey={(location) => {
          return location.pathname;
        }}
      />
    </>
  );
}
